module.exports = __webpack_public_path__ + "static/media/icon_setting.3d0c92e0.png";